<template>
  <div>
    <ProductCartModal />
    <InviteFriendsModal />
    <nav class="navbar navbar-expand-lg">
      <div class="col-9 col-md-10 col-lg-3 no-pdd">
        <div class="logo">
          <a class="navbar-brand ml-0">
            <img alt="" src="../../assets/logo.png" />
          </a>

          <div class="form-inline">
            <button>
              <img
                class="search-image"
                alt=""
                src="../../assets/images/search.png"
              />
            </button>
            <input
              v-model="searchTerm"
              aria-label="Search"
              class="form-control border-0"
              placeholder="Search"
              type="search"
              v-on:keyup.enter="searchValue"
            />
          </div>
        </div>
      </div>
      <button
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler custom-toggler"
        data-target="#navbarSupportedContent"
        data-toggle="collapse"
        type="button"
        @click="fetchUserAssociationNames()"
      >
        <img src="../../assets/images/box-score-list.png" />
      </button>

      <div
        id="navbarSupportedContent"
        class="col-lg-6 col-12 p-0 collapse navbar-collapse"
      >
        <div class="navbar-nav mx-auto">
          <div v-if="user" class="small-menu-user-info">
            <div class="user-img mr-0">
              <img
                v-if="user.picture == 'yes'"
                :src="API_URL + user.id + '/profile_picture.jpg?v=' + time"
                alt=""
              />
              <img
                v-else
                alt=""
                src="../../assets/images/user-default-new.png"
              />
            </div>
            <div class="user-name-pro position-relative">
              <router-link
                class="user-name ml-0"
                v-if="user.pro_status != null"
                style="color: black; margin-top: -6px"
                to="/profile"
              >
                {{ user.name }}
              </router-link>
              <router-link
                class="user-name mx-0"
                v-else-if="user.pro_status == null"
                style="color: black"
                to="/profile"
              >
                {{ user.name }}
              </router-link>
              <div class="proUser" v-if="user.pro_status != null">
                {{ user.pro_name }} expires on
                {{ user.pro_expiry | formatDateOfBirth }}
              </div>
            </div>
          </div>
          <router-link
            class="nav-item nav-link"
            exact
            to="/teams"
            @click.native="myFunction"
          >
            <div class="menu-img-bg"><img :src="imageTeam" alt="" /></div>
            <span>I Follow</span>
            <span
              v-if="
                currentUrl != '/teams' &&
                  teamsChatCounter + individualChatCounter > 0 &&
                  teamsChatCounter + individualChatCounter <= 9
              "
              class="nav-counter nav-team-counter text-center text-white"
              >{{ teamsChatCounter + individualChatCounter }}</span
            >
            <span
              v-else-if="
                currentUrl != '/teams' &&
                  teamsChatCounter + individualChatCounter > 0 &&
                  teamsChatCounter + individualChatCounter > 9
              "
              class="nav-counter nav-team-counter text-center text-white"
              >9+</span
            >
          </router-link>
          <router-link
            class="small-menu-shopping-cart nav-link d-lg-none"
            exact
            to="/"
          >
            <div class="menu-img-bg">
              <img :src="imageHome" alt="" />
            </div>
            <span>Opinions</span>
          </router-link>
          <router-link class="nav-link" exact to="/events">
            <div class="menu-img-bg"><img :src="imageGameTime" alt="" /></div>
            <span>Game Time</span>
          </router-link>
          <router-link
            class="nav-link nav-link-calendar"
            exact
            to="/event-list"
          >
            <div class="menu-img-bg"><img :src="imageEvents" alt="" /></div>
            <span id="calendar-nav">Calendar</span>
          </router-link>

          <!-- <div class="small-menu-shopping-cart">
            <router-link class="m-0" exact to="/box-scores">
              <div class="menu-img-bg">
                <img :src="imageBoxScore" alt="" />
              </div>
              <span class="">Box Scores</span>
            </router-link>
          </div> -->

          <router-link class="nav-link nav-link-shop" exact to="/shop">
            <div class="menu-img-bg"><img :src="imageShop" alt="" /></div>
            <span id="shop-nav">Shop</span>
          </router-link>

          <!-- <router-link class="nav-link" exact to="/events">
            <div class="menu-img-bg"><img :src="imageEventList" alt="" /></div>
            <span>Events</span>
          </router-link> -->

          <router-link
            class="small-menu-shopping-cart nav-link d-lg-none"
            exact
            to="/pros"
          >
            <div class="menu-img-bg"><img :src="imageSpecialist" alt="" /></div>
            <span>Specialists</span>
          </router-link>

          <router-link
            class="small-menu-shopping-cart nav-link d-lg-none"
            exact
            to="/friends"
          >
            <div class="menu-img-bg"><img :src="imageFriends" alt="" /></div>
            <span>Friends</span>
          </router-link>

          <!-- <router-link
            class="small-menu-shopping-cart nav-link d-lg-none"
            exact
            to="/live-stream"
          >
            <div class="menu-img-bg">
              <img :src="liveStream" alt="" />
            </div>
            <span>Live Stream</span>
          </router-link> -->

          <div class="small-menu-shopping-cart">
            <router-link class="m-0" exact to="/order-history">
              <div class="menu-img-bg">
                <img :src="imageOrderHistory" alt="" />
              </div>
              <span>Orders</span>
            </router-link>
          </div>

          <div
            class="small-menu-shopping-cart"
            data-target="#feedBackModal"
            data-toggle="modal"
          >
            <div class="menu-img-bg">
              <img alt="" src="../../assets/images/feedback-grey.png" />
            </div>
            <span>Feedback</span>
          </div>

          <div class="small-menu-shopping-cart" @click="callModal()">
            <div class="menu-img-bg">
              <img src="../../assets/images/search-add-friend.png" alt="" />
            </div>
            <span>Invite Friends</span>
          </div>

          <!-- <router-link
            class="nav-link go-pro-btn"
            exact
            to="/go-pro"
            v-if="user && user.pro_status == null"
          >
            <div class="menu-img-bg">
              <img src="../../assets/go-pro.png" alt="" />
            </div>
            <span>Go Pro</span>
          </router-link> -->
          <div
            class="small-menu-shopping-cart"
            data-target="#ProductCart"
            data-toggle="modal"
          >
            <div class="menu-img-bg">
              <img alt="" src="../../assets/images/shopping-cart-blue.png" />
            </div>
            Shopping Cart
            <span
              v-if="cartItemCount > 0 && cartItemCount < 10"
              class="nav-counter-shop text-center text-white"
              >{{ cartItemCount }}</span
            >
            <span
              v-if="cartItemCount > 0 && cartItemCount > 9"
              class="nav-counter-shop text-center text-white"
              >9+</span
            >
          </div>

          <div v-if="user">
            <div
              class="small-menu-shopping-cart justify-content-between"
              v-if="user.wallet != null"
            >
              <div class="nav-wrap" @click="callWallet(true)">
                <div class="menu-img-bg">
                  <img alt="" src="../../assets/images/wallet-grey.png" />
                </div>
                <div>
                  <p>Wallet Balance</p>
                  <span>{{ user.wallet.toFixed(2) }} $ </span>
                </div>
              </div>
              <div class="nav-wrap justify-content-between">
                <span class="wallet-span-mobile" @click="callWallet(true)"
                  >Show History</span
                >
                <button
                  type="button"
                  class="refresh"
                  @click="refreshWalletMobile(0)"
                  :disabled="isLoadingArray[0]"
                >
                  <div
                    v-if="isLoadingArray[0]"
                    class="lds-dual-ring-refresh"
                  ></div>
                  <span v-else>
                    <img src="../../assets/images/refresh-blue.png" alt="" />
                  </span>
                </button>
              </div>
            </div>
            <div
              class="small-menu-shopping-cart justify-content-between"
              v-else
            >
              <div class="nav-wrap" @click="callWallet(false)">
                <div class="menu-img-bg">
                  <img alt="" src="../../assets/images/wallet-grey.png" />
                </div>
                <div>
                  <p>Wallet Balance</p>
                  <span>0 $</span>
                </div>
              </div>
              <button
                type="button"
                class="refresh"
                @click="refreshWalletMobile(0)"
                :disabled="isLoadingArray[0]"
              >
                <div
                  v-if="isLoadingArray[0]"
                  class="lds-dual-ring-refresh"
                ></div>
                <span v-else>
                  <img src="../../assets/images/refresh-blue.png" alt="" />
                </span>
              </button>
            </div>
          </div>

          <div class="small-menu-shopping-cart">
            <div class="nav-wrap" @click="mobileNotification">
              <div class="menu-img-bg">
                <!-- <img alt="" :src="imageNotification" /> -->
                <img src="../../assets/images/notification-blue.png" alt="" />
              </div>
              <span>Notifications</span>
              <span
                v-if="notificationCounter > 0 && notificationCounter < 10"
                class="nav-counter-shop text-center text-white"
                >{{ notificationCounter }}</span
              >
              <span
                v-if="notificationCounter > 0 && notificationCounter > 9"
                class="nav-counter-shop text-center text-white"
                >9+</span
              >
            </div>
          </div>
          <div class="small-menu-shopping-cart" v-if="associationtLoader" >
            <div class="w-100 mt-2">
              <content-placeholders :rounded="true">
                  <content-placeholders-text :lines="2" />
             </content-placeholders>
            </div>
          </div>

          <div class="small-menu-shopping-cart" v-if="associationNames.length > 0 && associationtLoader == 0" >
            <div class="nav-wrap dropdown w-100">
              <div class="w-100 d-flex align-items-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <div class="menu-img-bg mr-3">
                    <img src="../../assets/images/courthouse.png" alt="" />
                  </div>
                  <div class="w-100 d-flex justify-content-between">
                      <span>Association</span>
                      <div class="association-img-loader" v-if="associationtLoader">
                        <div class="lds-dual-ring-media"></div>
                      </div>
                      <img src="../../assets/images/arrow-right.png" v-else />
                  </div>
              </div>

              <div class=" dropdown-menu mt-3" aria-labelledby="dropdownMenuButton">
                <!-- Dropdown content here -->
                <li
                  v-for="association in associationNames"
                  :key="association.guid"
                  @click="navigateToAssociationEvents(association)"
                >
                  {{ association.association_name }}
                </li>
              </div>
            </div>
          </div>
          
          <!-- <div class="small-menu-shopping-cart">
            <router-link class="m-0 " exact to="/event-calendar">
              <div class="menu-img-bg">
                <img alt="" src="../../assets/events.png" />
              </div>
              <span>Events</span>
            </router-link>
          </div> -->
          <!-- <div class="small-menu-user-menu">
            <img src="../../assets/setting-black.png" alt="" />
            Settings
          </div> -->

          <!-- <div class="small-menu-shopping-cart" @click="deleteAccount()">
            <div class="menu-img-bg">
              <img src="../../assets/invite-2.png" alt="" />
            </div>
            <span>Delete Account</span>
          </div> -->
          
          
          <div class="small-menu-shopping-cart">
            <div class="menu-img-bg">
              <img :src="imagePending" alt="" />
            </div>
            <router-link class="m-0 w-100 justify-content-between" exact to="/pending-invite">
              <span class="">Pending Invites</span>
                <span class= "pend-nvites" v-if="inviteCount > 9">+9</span>
                <span class= "pend-nvites"  v-else>{{inviteCount}}</span>
            </router-link>
          </div>
          <div class="small-menu-shopping-cart" v-if="subscribedInfo">
            <div class="menu-img-bg" v-if="subscribedInfo.pack_type != 2">
              <img :src="userInvite" alt="" />
            </div>
            <router-link class="m-0" exact to="/user-invites">
              <span
                v-if="
                  subscribedInfo &&
                    subscribedInfo.pack_type == 1 &&
                    subscribedInfo.pack_type != 2
                "
                >Pro/Super Users</span
              >
              <span
                v-else-if="
                  subscribedInfo &&
                    subscribedInfo.pack_type == 3 &&
                    subscribedInfo.pack_type != 2
                "
                >Pro Users</span
              >
            </router-link>
          </div>
          <div class="small-menu-shopping-cart">
            <div class="menu-img-bg">
              <img :src="imageSetting" alt="" />
            </div>
            <router-link class="m-0" exact to="/settings">
              <span class="">Settings</span>
            </router-link>
          </div>
          <div class="small-menu-logout" @click="logout()">
            <div class="menu-img-bg">
              <img alt="" src="../../assets/images/logout-grey.png" />
            </div>
            <span>Logout</span>
          </div>
        </div>
      </div>
      <div class="col-3 d-none d-lg-block px-0">
        <div class="user-side ml-auto">
          <div v-if="user" class="user-info">
            <div class="user-img">
              <div class="users-notification" v-if="imgLoader == 1">
                <!-- <div class="lds-dual-ring-refresh"></div> -->
                <img src="../../assets/loader.gif" alt="" />
              </div>
              <img
                @load="onImageLoad"
                v-if="user.picture == 'yes'"
                :src="API_URL + user.id + '/profile_picture.jpg?v=' + time"
                alt=""
              />
              <img
                @load="onImageLoad"
                v-else
                alt=""
                src="../../assets/images/user-default-new.png"
              />
            </div>
            <div class="user-name-pro position-relative">
              <router-link
                class="user-name ml-0"
                v-if="user.pro_status != null"
                style="color: black"
                to="/profile"
              >
                {{ user.name }}
              </router-link>
              <router-link
                class="user-name mx-0"
                v-else-if="user.pro_status == null"
                style="color: black"
                to="/profile"
              >
                {{ user.name }}
              </router-link>
              <div class="proUser" v-if="user.pro_status != null">
                {{ user.pro_name }} expires on
                {{ user.pro_expiry | formatDateOfBirth }}
              </div>
            </div>
          </div>
          <div class="shopping-cart" @click="openCartModal">
            <img alt="" src="../../assets/images/shopping-cart-blue.png" />
            <span
              v-if="cartItemCount > 0 && cartItemCount < 10"
              class="nav-counter-shop text-center text-white"
              >{{ cartItemCount }}</span
            >
            <span
              v-if="cartItemCount > 0 && cartItemCount > 9"
              class="nav-counter-shop text-center text-white"
              >+9</span
            >
          </div>
          <div
            v-click-outside="notificationOutside"
            class="notification"
            @click="openNotification"
          >
            <img alt="" src="../../assets/images/notification-blue.png" />
            <span
              v-if="notificationCounter > 0 && notificationCounter < 10"
              class="nav-counter-shop text-center text-white"
              >{{ notificationCounter }}</span
            >
            <span
              v-if="notificationCounter > 0 && notificationCounter > 9"
              class="nav-counter-shop text-center text-white"
              >+9</span
            >
          </div>
          <div
            v-click-outside="onClickOutside"
            class="user-menu"
            @click="openSettingOptions"
          >
            <img alt="" src="../../assets/images/dropdown.png" />
          </div>
        </div>
      </div>
    </nav>

    <div v-if="notifyOptions" class="setting-options">
      <ul>
        <div>
          <!-- <li>
            <a
              class="d-flex align-items-center"
              data-target="#feedBackModal"
              data-toggle="modal"
              ><img
                alt=""
                class="mr-3"
                src="../../assets/feedback.png"
              />Feedback</a
            >
          </li> -->
          <!-- <li>
            <router-link
              class="d-flex align-items-center"
              style="color: black"
              to="/order-history"
            >
              <img alt="" class="mr-3" src="../../assets/shop.png" /> Order
              History
            </router-link>
          </li> -->
          <!-- <li>
            <router-link
              class="d-flex align-items-center"
              style="color: black"
              to="/event-calendar"
            >
              <img alt="" class="mr-3" src="../../assets/events.png" /> Events
            </router-link>
          </li> -->

          <!-- <li>
            <a class="d-flex align-items-center"
              ><img alt="" class="mr-3" src="../../assets/help.png" />Help &
              Support</a
            >
          </li>
          <li>
            <a class="d-flex align-items-center"
              ><img
                alt=""
                class="mr-3"
                src="../../assets/settings.png"
              />Settings</a
            >
          </li> -->
          <span v-if="user">
            <li v-if="user.wallet != null">
              <a class="d-flex align-items-center justify-content-between">
                <div
                  class="d-flex align-items-center"
                  @click="callWallet(true)"
                >
                  <img
                    class="mr-3"
                    alt=""
                    src="../../assets/images/wallet-blue.png"
                  />
                  <div>
                    <p>Wallet Balance</p>
                    <span>{{ user.wallet.toFixed(2) }} $</span>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <span class="wallet-span mr-3" @click="callWallet(true)"
                    >Show history</span
                  >
                  <button
                    type="button"
                    class="refresh"
                    @click="refreshWallet(0)"
                    :disabled="isLoadingArray[0]"
                  >
                    <div
                      v-if="isLoadingArray[0]"
                      class="lds-dual-ring-refresh"
                    ></div>
                    <span v-else>
                      <img src="../../assets/images/refresh-blue.png" alt="" />
                    </span>
                  </button>
                </div>
              </a>
            </li>
            <li v-else>
              <a class="d-flex align-items-center justify-content-between">
                <div
                  class="d-flex align-items-center"
                  @click="callWallet(false)"
                >
                  <div>
                    <img
                      class="mr-3"
                      alt=""
                      src="../../assets/images/wallet-blue.png"
                    />
                  </div>
                  <div>
                    <div>
                      <p>Wallet Balance</p>
                      <div class="wallet-balance">0 $</div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="refresh"
                  @click="refreshWallet(0)"
                  :disabled="isLoadingArray[0]"
                >
                  <div
                    v-if="isLoadingArray[0]"
                    class="lds-dual-ring-refresh"
                  ></div>
                  <span v-else>
                    <img src="../../assets/images/refresh-blue.png" alt="" />
                  </span>
                </button>
              </a>
            </li>
          </span>
        </div>
        <!-- <li @click="deleteAccount()">
            <a class="d-flex align-items-center"
              ><img alt="" class="mr-3" src="../../assets/logoutt.png" />Delete
              Account</a
            >
          </li> -->
        <div>
          <li v-if="subscribedInfo">
            <router-link class="m-0" exact to="/user-invites">
              <img
                v-if="subscribedInfo.pack_type != 2"
                alt=""
                class="mr-3"
                :src="userInvite"
              />
              <span
                v-if="
                  subscribedInfo &&
                    subscribedInfo.pack_type == 1 &&
                    subscribedInfo.pack_type != 2
                "
                >Pro/Super Users</span
              >
              <span
                v-else-if="
                  subscribedInfo &&
                    subscribedInfo.pack_type == 3 &&
                    subscribedInfo.pack_type != 2
                "
                >Pro Users</span
              >
            </router-link>
          </li>
          <li v-if=associationtLoader>
            <content-placeholders :rounded="true">
                  <content-placeholders-text :lines="2" />
             </content-placeholders>
          </li>

          <li v-if="associationNames.length > 0 && associationtLoader == 0" class="dropdown w-100">
            <div class="d-flex align-items-center nav-item dropdown">
              <img class="mr-3" src="../../assets/images/courthouse.png" />
              <div
                class="d-flex w-100 justify-content-between align-items-center"
              >
                <button class="dropbtn" :disabled="associationtLoader">Association</button>
                <div class="association-img-loader" v-if="associationtLoader">
                  <div class="lds-dual-ring-media"></div>
                </div>
                <img src="../../assets/images/arrow-right.png" v-else />
              </div>

              <div class="dropdown-content">
                <li
                  v-for="association in associationNames"
                  :key="association.guid"
                  @click="navigateToAssociationEvents(association)"
                >
                  {{ association.association_name }}
                </li>
              </div>
            </div>
          </li>
          <li v-if="associationtLoader == 0">
            <router-link class="m-0 d-flex align-items-center" exact to="/pending-invite">
              <img
                alt=""
                class="mr-3"
                src="../../assets/images/setting-notification.png"
              />
              <div class="w-100 d-flex justify-content-between">
                <span class="">Pending Invites</span>
                <span class= "pend-nvites" v-if="inviteCount > 9">+9</span>
                <span class= "pend-nvites"  v-else>{{inviteCount}}</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link class="m-0" exact to="/settings">
              <img
                alt=""
                class="mr-3"
                src="../../assets/images/setting-blue.png"
              />
              <span class="">Settings</span>
            </router-link>
          </li>
          <li @click="logout()">
            <a class="d-flex align-items-center"
              ><img
                alt=""
                class="mr-3"
                src="../../assets/images/logout-blue.png"
              />Logout</a
            >
          </li>
        </div>
        <li>
          <router-link class="terms-and-conditions" to="/terms-and-conditions"
            >Terms & Conditions
          </router-link>
          <!-- <a class="d-flex align-items-center">Terms & Conditions</a> -->
        </li>
        <li>
          <router-link class="privacy-policy" to="/privacy-policy"
            >Privacy Policy
          </router-link>
        </li>
        <span class="who-i-follow">© {{ currYear }} Who I Follow.</span>
      </ul>
    </div>

    <div v-if="notificationOpen">
      <Notification />
    </div>
    <!-- Modal -->
    <!-- <div
      id="ProductCart"
      aria-hidden="true"
      aria-labelledby="exampleModalLabel"
      class="modal fade"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog my-0 product-cart-modal " role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <div class="container-fluid no-pdd">
              <div class="row no-gutters">
                <div class="col-8 col-md-8 col-lg-9 p-3">
                  <router-link
                    class="back-link"
                    data-dismiss="modal"
                    exact
                    to="/shop"
                    >Back To Products
                  </router-link>
                </div>
                <div class="col-4 col-md-4 col-lg-3 cart-cross-section">
                  <button
                    ref="closeModalShoppingCart"
                    aria-label="Close"
                    class="close"
                    data-dismiss="modal"
                    type="button"
                    @click="showScroll()"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body pt-0 pl-0 pr-0 pb-0">
            <div class="container-fluid no-pdd">
              <div class="row no-gutters">
                <div class="col-sm-12 col-md-8 col-lg-9 p-3">
                  <CartHeading />
                  <ItemsHeading />
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 p-0">
                  <Summary />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Modal -->
    <walletHistory />
    <!-- FeedBack Modal -->
    <div
      id="feedBackModal"
      aria-hidden="true"
      aria-labelledby="feedBackModal"
      class="modal fade"
      role="dialog"
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h6>Give us your feedback.</h6>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row no-gutters">
              <div class="col-12 col-sm-6 pr-0 pr-sm-3">
                <button
                  class="feedbackDiv w-100 selectedBtn text-center"
                  @click="feedbackType(1)"
                >
                  <div>
                    <img
                      alt=""
                      height="72px"
                      src="../../assets/rocket.png"
                      width="68px"
                    />
                    <h4>How we can improve Who I Follow</h4>
                  </div>
                </button>
              </div>
              <div class="col-12 col-sm-6 mt-3 mt-sm-0">
                <button
                  class="feedbackDiv text-center w-100"
                  @click="feedbackType(2)"
                >
                  <div>
                    <img
                      alt=""
                      height="72px"
                      src="../../assets/wentWrong.png"
                      width="68px"
                    />
                    <h4>Something Went Wrong</h4>
                  </div>
                </button>
              </div>

              <div class="event-btns-wrapper col-12 pt-3">
                <button
                  class="btn main-btn w-100"
                  data-backdrop="static"
                  data-dismiss="modal"
                  data-keyboard="false"
                  data-target="#feedBackResponseModal"
                  data-toggle="modal"
                  type="button"
                  @click="contuinueFeedbackHandler"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FeedBack Response Modal -->

    <div
      id="feedBackResponseModal"
      aria-hidden="true"
      aria-labelledby="feedBackResponseModal"
      class="modal fade"
      role="dialog"
    >
      <!--   tabindex="-1"   -->
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6>Give us your feedback.</h6>

            <button
              ref="closeModalResponseFeedback"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-4">
            <form
              @submit.prevent="feedbackResoponse"
              enctype="multipart/form-data"
            >
              <div class="row no-gutters">
                <div class="col-12">
                  <div
                    class="form-group"
                    style="margin-bottom: 15px !important"
                  >
                    <select
                      id="feedbacktypelist"
                      v-model.trim="$v.feedbackresponse.feedbacktypelist.$model"
                      :class="{
                        'is-invalid': validationStatus(
                          $v.feedbackresponse.feedbacktypelist
                        ),
                      }"
                      class="inputProblem form-control select2 select2-hidden-accessible"
                      name="feedbacktypelist"
                      aria-hidden="true"
                      @change="errorNull"
                    >
                      <option :key="'allowance_id'" value="" disabled>
                        Select Category
                      </option>

                      <option
                        v-for="(item, index) in selectBox"
                        v-bind:key="index"
                        :value="item.id"
                        class="feedback-options"
                      >
                        {{ item.title }}
                      </option>
                    </select>

                    <div
                      v-if="
                        !$v.feedbackresponse.feedbacktypelist.required &&
                          validationserror
                      "
                      class="invalid-feedback error-message"
                    >
                      Select Category
                    </div>
                  </div>

                  <div class="form-group mb-0 mt-4">
                    <input
                      v-model.trim="$v.feedbackresponse.feedbacktitle.$model"
                      :class="{
                        'is-invalid': validationStatus(
                          $v.feedbackresponse.feedbacktitle
                        ),
                      }"
                      class="inputProblem"
                      placeholder="Title"
                      type="text"
                      @keyup="errorNull"
                    />

                    <div
                      v-if="
                        !$v.feedbackresponse.feedbacktitle.required &&
                          validationserror
                      "
                      class="invalid-feedback error-message"
                    >
                      Enter Title
                    </div>
                    <div
                      v-if="
                        !$v.feedbackresponse.feedbacktitle.maxLength &&
                          validationserror
                      "
                      class="invalid-feedback error-message"
                    >
                      max characters 255
                    </div>
                  </div>

                  <div class="form-group">
                    <textarea
                      id="description"
                      v-model.trim="$v.feedbackresponse.description.$model"
                      :class="{
                        'is-invalid': validationStatus(
                          $v.feedbackresponse.description
                        ),
                      }"
                      class="inputProblemDescription"
                      placeholder="Description"
                      rows="5"
                      @keyup="errorNull"
                    ></textarea>

                    <div
                      v-if="
                        !$v.feedbackresponse.description.required &&
                          validationserror
                      "
                      class="invalid-feedback error-message"
                      style="top: 7%"
                    >
                      Enter Description
                    </div>

                    <div
                      v-if="
                        !$v.feedbackresponse.description.maxLength &&
                          validationserror
                      "
                      class="invalid-feedback error-message"
                    >
                      max characters 255
                    </div>
                  </div>

                  <div class="form-group">
                    <!--                    <button class="uploadBtn" type="button">-->
                    <!--                      <input-->
                    <!--                          ref="file"-->
                    <!--                          accept="image/*"-->
                    <!--                          class="uploadFile"-->
                    <!--                          type="file"-->
                    <!--                          @change="onFileUpload"-->
                    <!--                      />-->
                    <!--                      Upload Attachment-->
                    <!--                    </button>-->
                    <div
                      v-if="FILE !== null"
                      class="mt-3 feedback-image-section"
                    >
                      <span> {{ FILE.name }}</span>
                      <span
                        aria-hidden="true"
                        class="image-delete-icon"
                        @click="removeAttachemt"
                        >&times;</span
                      >
                    </div>
                  </div>
                </div>

                <div class="event-btns-wrapper col-12">
                  <!--        data-dismiss="modal"        -->

                  <button
                    v-if="this.isDisabled == false"
                    type="submit"
                    class="btn btn-primary w-100"
                    :disabled="isLoadingArrayFeedback[0]"
                  >
                    <div
                      v-if="isLoadingArrayFeedback[0]"
                      class="lds-dual-ring"
                    ></div>
                    <span v-else>Submit</span>
                  </button>
                  <button
                    v-else-if="this.isDisabled == true"
                    type="submit"
                    class="btn btn-primary-disabled w-100"
                    :disabled="isLoadingArrayFeedback[0]"
                  >
                    <div
                      v-if="isLoadingArrayFeedback[0]"
                      class="lds-dual-ring"
                    ></div>
                    <span v-else>Submit</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal ref="ReportStatusmodal" :icon="reportStatus">
      {{ this.reportStatusMessage }}
    </sweet-modal>

    <!--    end feedback-->
  </div>
</template>
<script>
import { SweetModal } from "sweet-modal-vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import Notification from "./Notification.vue";
import * as firestoreService from "../../database/firestore";
import * as firestoreServe from "../../database/firebase";
import Pusher from "pusher-js";
import store from "../../store";
import { maxLength, required } from "vuelidate/lib/validators";
import walletHistory from "../Home/walletHistory.vue";
import $ from "jquery";
import Favico from "favico.js-slevomat";
import InviteFriendsModal from "../Home/InviteFriendsModal.vue";
import ProductCartModal from "../Shop/ProductsDetails/ProductCartModal";
// import Echo from 'laravel-echo';

export default {
  components: {
    Notification,
    walletHistory,
    InviteFriendsModal,
    ProductCartModal,
    SweetModal,
  },
  name: "Navbar",
  data() {
    return {
      reportStatus: "success",
      reportStatusMessage: "",
      imgLoader: 1,
      associationtLoader: 1,
      opts: [],
      allowance_id: [],
      associationNames: [],
      selectBox: "",
      feedbacktype: 1,
      FILE: null,
      inviteCount: '',
      loading: false,
      feedbackresponse: {
        feedbacktypelist: "",
        feedbacktitle: "",
        description: "",
      },
      validationserror: false,
      currentTabUrl: "",
      notifyOptions: false,
      notificationOpen: false,
      time: this.$time,
      API_URL: this.$userProfileStorageURL,
      GameTimeGrey: require("../../assets/images/gametimegrey.png"),
      imageGameTime: require("../../assets/images/gametimegrey.png"),
      GameTimeBlue: require("../../assets/images/gametimeblue.png"),
      imageHome: require("../../assets/images/firstline.png"),
      homeGrey: require("../../assets/images/opinion-grey.png"),
      imageTeam: require("../../assets/images/team.png"),
      friendsGrey: require("../../assets/images/friend-grey.png"),
      imageFriends: require("../../assets/images/friend-grey.png"),
      imageShop: require("../../assets/images/shop.png"),
      imageEventList: require("../../assets/images/events.png"),
      imageSpecialist: require("../../assets/images/specialist-grey.png"),
      imageEvents: require("../../assets/images/calendar.png"),
      imageOrderHistory: require("../../assets/images/order-grey.png"),
      imageBoxScore: require("../../assets/images/box-score-grey.png"),
      imageSetting: require("../../assets/images/setting-blue.png"),
      imagePending: require("../../assets/images/setting-notification.png"),
      BoxScoreGrey: require("../../assets/images/box-score-grey.png"),
      BoxScoreblue: require("../../assets/images/boxscore.png"),
      settingBlue: require("../../assets/images/setting-blue.png"),
      settingGrey: require("../../assets/images/setting-blue.png"),
      teamGrey: require("../../assets/images/team-grey.png"),
      teamBlue: require("../../assets/images/team.png"),
      shopGrey: require("../../assets/images/shop-grey.png"),
      shopTopGrey: require("../../assets/images/events.png"),
      shopBlue: require("../../assets/images/shop.png"),
      shopTopBlue: require("../../assets/images/event_blue.png"),
      eventsBlue: require("../../assets/images/calendar.png"),
      eventsGrey: require("../../assets/images/calendar-grey.png"),
      specialistsGrey: require("../../assets/images/specialist-grey.png"),
      specialistsBlue: require("../../assets/images/specialist.png"),
      orderHistoryGrey: require("../../assets/order-grey.png"),
      orderHistoryBlue: require("../../assets/order.png"),
      resetIcon: require("../../assets/favicon.png"),
      roomsPerPage: 5000,
      startRooms: null,
      currentUserId: "",
      foundCurrentUser: [],
      allUsersRef: [],
      teamsChatCounter: 0,
      individualChatCounter: 0,
      userId: localStorage.getItem("userId"),
      userName: localStorage.getItem("userName"),
      roomsListeners: [],
      currentUrl: "/",
      searchTerm: "",
      searchTermTrim: "",
      searchTermNew: "",
      check: 0,
      isLoadingArray: [],
      isLoadingArrayFeedback: [],
      refreshBtn: false,
      fullPage: false,
      isDisabled: true,
      liveStreamBlue: require("../../assets/images/wifi-square-active.png"),
      liveStreamGrey: require("../../assets/images/wifi-square.png"),
      liveStream: require("../../assets/images/wifi-square.png"),
      userInviteBlue: require("../../assets/images/setting-accounts.png"),
      userInviteGrey: require("../../assets/images/setting-account.png"),
      userInvite: require("../../assets/images/setting-account.png"),
      currYear: new Date().getFullYear(),
    };
  },
  validations: {
    feedbackresponse: {
      feedbacktitle: {
        required,
        maxLength: maxLength(255),
      },
      feedbacktypelist: {
        required,
      },
      description: {
        required,
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("cart", ["cartItemCount"]),
    ...mapGetters("notification", ["notificationCounter"]),
    ...mapGetters("auth", ["subscribedInfo"]),
  },
  methods: {
    ...mapActions("notification", ["getUserCheckedNotification"]),
    ...mapActions("notification", ["setCounterCheck"]),
    ...mapActions("notification", ["clearNotifications"]),
    ...mapActions({
      clearCartItems: "cart/clearCartItems",
    }),

    onImageLoad() {
      this.imgLoader = 0;
    },

    errorNull: function() {
      if (
        this.feedbackresponse.feedbacktypelist == "" ||
        this.feedbackresponse.feedbacktitle == "" ||
        this.feedbackresponse.description == ""
      ) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    searchValue() {
      if (this.searchTerm.trim() != "") {
        this.searchTermTrim = this.searchTerm.trim();
        this.searchTermNew = this.searchTermTrim.replace(/ /g, "2022");
        this.currentTabUrl = window.location.pathname;
        const str = this.currentTabUrl;
        const split = str.split("rch/");
        if (split[0] == "/sea") {
          this.$router
            .push({ path: `/search/${this.searchTermNew}` })
            .catch(() => {});
          window.location.reload();
        } else {
          this.$router
            .push({ path: `/search/${this.searchTermNew}` })
            .catch(() => {});
        }
      }
    },
    openCartModal: function() {
      this.$root.$emit("openProductCartModal");
    },
    openSettingOptions() {
      this.notifyOptions = !this.notifyOptions;
      this.fetchUserAssociationNames();
    },
    fetchUserAssociationNames() {
      this.associationtLoader = 1;
      axios
        .post(process.env.VUE_APP_API_URL + "association/checkUserAssociations")
        .then((response) => {
          this.associationNames = response.data.associations;
          this.inviteCount=response.data.invite_sum;
          this.associationtLoader = 0;
        })
        .catch((error) => {
          console.error("Error fetching association names:", error);
          this.associationtLoader = 0;
        });
    },
 
    navigateToAssociationEvents(association) {
        this.$root.$emit("associationRoute", association );
        this.$router.push({ name: 'AssociationEvents', params: { associationGuid: association.guid } });
    },


    openNotification() {
      this.notificationOpen = !this.notificationOpen;
      this.setCounterCheck();
    },
    mobileNotification() {
      this.setCounterCheck();
      this.$router.push({ name: "NotificationContent" });
    },
    myFunction() {
      this.currentUrl = window.location.pathname;
      localStorage.setItem("currentUrl", this.currentUrl);
      this.imageSwap();
    },
    imageSwap() {
      this.currentTabUrl = localStorage.getItem("currentUrl");

      if (this.currentTabUrl == "/my-teams") {
        this.imageTeam = this.teamGrey;
        this.imageHome = this.homeGrey;
        this.imageGameTime = this.GameTimeBlue;
        this.imageShop = this.shopGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/teams") {
        this.imageTeam = this.teamBlue;
        this.imageGameTime = this.GameTimeGrey;
        this.imageShop = this.shopGrey;
        this.imageHome = this.homeGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (
        this.currentTabUrl == "/shop" ||
        this.currentTabUrl == "/product-detail/:guid?" ||
        this.currentTabUrl == "/order" ||
        this.currentTabUrl == "/shipping" ||
        this.currentTabUrl == "/payment"
      ) {
        this.imageShop = this.shopBlue;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
        document.getElementById("shop-nav").style.color = "#188ef5";
        document.querySelector(".nav-link-shop").style.borderBottom =
          "4px solid #188ef5";
      } else if (
        this.currentTabUrl == "/event-calendar" ||
        this.currentTabUrl == "/event-list" ||
        this.currentTabUrl == "/event-calendar-table"
      ) {
        this.imageEvents = this.eventsBlue;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageGameTime = this.GameTimeGrey;
        document.getElementById("calendar-nav").style.color = "#188ef5";
        document.querySelector(".nav-link-calendar").style.borderBottom =
          "4px solid #188ef5";
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/pros") {
        this.imageSpecialist = this.specialistsBlue;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/box-scores") {
        this.imageBoxScore = this.BoxScoreblue;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageHome = this.homeGrey;
        this.imageEventList = this.shopTopGrey;
      }
      // else if (this.currentTabUrl == "/notifications") {
      //   this.imageNotification= this.notificationBlue;
      //   this.imageShop = this.shopGrey;
      //   this.imageHome = this.homeGrey;
      //   this.imageTeam = this.teamGrey;
      //   this.imageEvents = this.eventsGrey;
      // }
      else if (this.currentTabUrl == "/setting") {
        this.imageSettting = this.setttingBlue;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageEvents = this.eventsGrey;
        this.imageHome = this.homeGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopGrey;
      } else if (this.currentTabUrl == "/order-history") {
        this.imageTeam = this.teamGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageShop = this.shopGrey;
        this.imageEvents = this.eventsGrey;
        this.imageSpecialist = this.specialistsGrey;
        this.imageOrderHistory = this.orderHistoryBlue;
        this.imageFriends = this.friendsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageHome = this.homeGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/live-stream") {
        this.boxScore = this.boxGrey;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageSpecialist = this.specialistsGrey;
        this.imageOrderHistory = this.orderHistoryGrey;
        this.imageFriends = this.friendsGrey;
        this.liveStream = this.liveStreamBlue;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/user-invites") {
        this.boxScore = this.boxGrey;
        this.imageShop = this.shopGrey;
        this.imageHome = this.homeGrey;
        this.imageTeam = this.teamGrey;
        this.imageSpecialist = this.specialistsGrey;
        this.imageOrderHistory = this.orderHistoryGrey;
        this.imageFriends = this.friendsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteBlue;
        this.imageHome = this.homeGrey;
        this.imageEventList = this.shopTopGrey;
      } else if (this.currentTabUrl == "/events") {
        this.imageEventList = this.shopTopBlue;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageEvents = this.eventsGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
      } else {
        this.imageEvents = this.eventsGrey;
        this.imageShop = this.shopGrey;
        this.imageGameTime = this.GameTimeGrey;
        this.imageTeam = this.teamGrey;
        this.imageHome = this.homeGrey;
        this.liveStream = this.liveStreamGrey;
        this.userInvite = this.userInviteGrey;
        this.imageEventList = this.shopTopGrey;
      }
    },
    handleIcon(allChatCounter) {
      var favicon = new Favico({
        animation: "none",
        position: "up",
      });
      if (allChatCounter == "0") {
        const favicon = document.getElementById("favicon");
        favicon.href = this.resetIcon;
      } else {
        favicon.badge(allChatCounter);
      }
    },
    onClickOutside() {
      if (this.refreshBtn == false) {
        this.notifyOptions = false;
      } else if (this.refreshBtn == true) {
        this.notifyOptions = true;
      }
    },
    notificationOutside() {
      this.notificationOpen = false;
    },
    ...mapActions("auth", ["sendLogoutRequest", "getUserData"]),
    logout() {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,

        color: "#ffffff",
        backgroundColor: "#333",
        opacity: 0.6,
      });
      this.sendLogoutRequest().then((response) => {
        if (response.data.statusCode == 200) {
          if (this.currentUserId !== "") {
            console.log(this.currentUserId);
            firestoreServe.updateUserOfflineStatus(this.currentUserId);
            this.currentUserId = "";
          }
          this.clearCartItems();

          this.clearNotifications();
          this.$router.push({ name: "Login" });
          loader.hide();
        }
      });
    },
    callWallet(tabsH) {
      this.$root.$emit("walletHistory", tabsH);
    },

    callModal() {
      this.$root.$emit("openInviteFriendsModal");
    },

    refreshWallet: function(index) {
      this.refreshBtn = true;
      this.$set(this.isLoadingArray, index, true);
      setTimeout(() => {
        this.$set(this.isLoadingArray, index, false);
        this.getUserData();
        this.refreshBtn = false;
        this.$root.$emit("walletHistoryAgain");
      }, 5000);
    },

    refreshWalletMobile: function(index) {
      this.$set(this.isLoadingArray, index, true);
      setTimeout(() => {
        this.$set(this.isLoadingArray, index, false);
        this.getUserData();
        this.$root.$emit("walletHistoryAgain");
      }, 5000);
    },

    // Chat Counter --------------------------------------------------------------------------
    async listenTeamsCounter() {
      // Check User on DB ---------------------------
      const rawUserCID = [];
      this.foundCurrentUser = "";
      const promiseID = firestoreService.getUserCid(this.userId.toString());
      rawUserCID.push(promiseID);
      const data = await Promise.all(rawUserCID);
      this.foundCurrentUser = data[0].data[0];
      if (this.foundCurrentUser != undefined) {
        this.currentUserId = this.foundCurrentUser.id;

        // Notification Counter --start ---
        const query = firestoreService.roomsQuery(
          this.currentUserId,
          this.roomsPerPage,
          this.startRooms,
          "",
          null
        );
        const listener = firestoreService.listenRooms(query, async (rooms) => {
          let teamsChatCounter = 0;
          let individualChatCounter = 0;

          // Create an array to hold promises for asynchronous room processing
          const roomProcessingPromises = rooms.map(async (room) => {
            const userIndex = room.userCount.findIndex(
              (c) => c.id === this.currentUserId
            );
            const counter =
              room.userCount[userIndex] === undefined
                ? 0
                : room.userCount[userIndex].count;
            if (counter > 0) {
              if (room.chatType == "team") {
                teamsChatCounter++;
              } else {
                individualChatCounter++;
              }
            }
          });

          // Wait for all room processing promises to resolve
          await Promise.all(roomProcessingPromises);

          const allChatCounter = individualChatCounter + teamsChatCounter;
          // Update the favicon after processing all rooms
          this.handleIcon(allChatCounter);
          // Emit the event with the final counters
          this.$root.$emit(
            "teamChatCounterForChatSystem",
            teamsChatCounter,
            individualChatCounter
          );
          // Add the total counts after processing all rooms
          this.teamsChatCounter = teamsChatCounter;
          this.individualChatCounter = individualChatCounter;
        });
        this.roomsListeners.push(listener);
        // Notification Counter --end
      }
    },

    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },

    // ====================== FeedBack ======================

    closeModal: function() {
      this.validationserror = false;
      this.feedbackresponse.feedbacktypelist = "";
      this.feedbackresponse.feedbacktitle = "";
      this.feedbackresponse.description = "";
      this.getselectedoptions();
      // document.querySelector("body").style.overflow = "visible";
      this.removeAttachemt();
      $(".select2")
        .val("")
        .trigger("change");
    },
    // feedback type

    validationStatus: function(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    async feedbackType(e) {
      this.feedbacktype = e;
    },
    // Continue feedback

    getselectedoptions() {
      this.allowances = [
        {
          id: 1,
          name: "selectcategory",
        },
      ];
    },

    async contuinueFeedbackHandler() {
      // document.querySelector("body").style.overflow = "hidden";
      this.opts = [];
      axios
        .get(process.env.VUE_APP_API_URL + "feedback/types/list?id=1")
        .then((response) => {
          this.selectBox = response.data.data;
          if (this.selectBox !== "") {
            this.selectBox.forEach((value) => {
              this.opts.push({ text: value.title, value: value.id });
            });
          }
        });
    },
    // Feedback response file uplaod
    async onFileUpload(event) {
      this.FILE = event.target.files[0];
    },
    async removeAttachemt() {
      this.FILE = null;
      this.$refs.file.value = "";
    },

    // Feedback response save
    onSelectChange(val) {
      this.feedbackresponse.feedbacktypelist = val;
    },

    feedbackResoponse: function(event, index) {
      this.isDisabled = true;
      this.validationserror = true;
      this.$v.feedbackresponse.$touch();
      // if its still pending or an error is returned do not submit
      if (this.$v.feedbackresponse.$pending || this.$v.feedbackresponse.$error)
        return;
      this.$set(this.isLoadingArrayFeedback, index, true);

      this.loading = true;

      setTimeout(
        function() {
          this.loading = false;
          this.$set(this.isLoadingArrayFeedback, index, false);
        }.bind(this),
        1000
      );

      const formData = new FormData();

      if (this.FILE != null) {
        formData.append("file", this.FILE, this.FILE.name);
      }

      formData.append("category_id", this.feedbackresponse.feedbacktypelist);
      formData.append("title", this.feedbackresponse.feedbacktitle);
      formData.append("description", this.feedbackresponse.description);
      formData.append("feed_type", this.feedbacktype);

      axios
        .post(process.env.VUE_APP_API_URL + "feedback/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if(res.data.statusCode == 200) {
            this.reportStatus = "success";
          }
          this.reportStatusMessage = res.data.message;
          this.$refs.ReportStatusmodal.open();
          event.target.reset();
          var elem = this.$refs.closeModalResponseFeedback;
          elem.click();
          this.closeModal();
        });
    },
    callCommentPusher(post_id, comment) {
      this.$root.$emit("newCommentArray", post_id, comment);
    },
    callReactionPusher(post_id, count) {
      this.$root.$emit("reactionCountUpdate", post_id, count);
    },
    onCancel() {
      this.loader = false;
    },
  },

  mounted() {
    if (this.currentUserId === "") {
      firestoreService
        .getUserCid(this.userId)
        .then((userData) => {
          const currentUserId = userData.data[0].id;
          firestoreServe.updateUserOnlineStatus(currentUserId);
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
        });
    }

    this.isDisabled = true;
    this.getselectedoptions();
    let self = this;
    $(".select2")
      .select2()
      .on("change", function() {
        self.onSelectChange(this.value);
      });

    this.getUserCheckedNotification();
    this.myFunction();
    this.imageSwap();
    this.listenTeamsCounter();
    this.$root.$on("navBarSearchText", (searchText) => {
      this.searchTerm = searchText;
    });
    this.$root.$on("refreshNavbarTeamNotification", () => {
      this.listenTeamsCounter();
    });

    // Send SMS for teams
    // setInterval(function () {
    //   var formData = new FormData();
    //   if (localStorage.getItem("authToken")) {
    //     return axios
    //       .post(
    //         process.env.VUE_APP_API_URL + "smsNotification/sendSMS",
    //         formData,
    //         {
    //           headers: {
    //             "Content-Type": "multipart/form-data",
    //           },
    //         }
    //       )
    //       .then(() => {});
    //   }
    // }, 80000);

    //   System Notification End --------------------------------------------------------------------------------------------------------------
    var pusher = new Pusher("e69ab0a1e1e1d1fbcd73", {
      cluster: "ap4",
    });
    window.test = this;
    var channel = pusher.subscribe("notification-channel");
    channel.bind("notification", function(e) {
      const platform = process.env.VUE_APP_PLATFORM;

      if (e.platform === platform) {
        if (JSON.stringify(e.user_id) === localStorage.getItem("userId")) {
          window.test.playSound(
            "http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3"
          );
          // var snd = new Audio("../../assets/notification.wav");
          // var snd = new Audio(
          // "data:audio/wav;base64,//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+ 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"
          // );
          // snd.play();

          const array = {
            id: JSON.stringify(e.id),
            table_id: JSON.stringify(e.table_id),
            message: e.message,
            message_type: e.message_type,
            read: JSON.stringify(e.read),
            user_id: JSON.stringify(e.user_id),
            checked: JSON.stringify(e.checked),
            send_by: JSON.stringify(e.send_by),
            sender_name: e.sender_name,
            sender_picture: e.sender_picture,
            sender_link: e.sender_link,
            created_at: e.created_at,
          };

          const oldcount = store.state.notification.notificationCounter;
          const oldArray = store.state.notification.notificationList;

          let notificationInArray = oldArray.find(
            (item) => item.id === array.id
          );

          if (!notificationInArray) {
            const finalarray = [array, ...oldArray];
            store.commit("notification/setNotificationData", finalarray);
            store.commit("notification/setNotificationCount", oldcount + 1);
          }

          if (array.message_type === 3) {
            window.test.$root.$emit("FriendRequestCountCheck");
          }
        }
      }
    });

    // Subscribe to the comment channel
    var channelComment = pusher.subscribe("comment-channel");
    channelComment.bind("comment", function(e) {
      const platform = process.env.VUE_APP_PLATFORM;
      if (e.platform === platform) {
        if (JSON.stringify(e.user_id) === localStorage.getItem("userId")) {
          window.test.callCommentPusher(e.post_id, JSON.parse(e.comment));
        }
      }
    });

    // Subscribe to the reaction channel
    var channelReaction = pusher.subscribe("reaction-channel");
    channelReaction.bind("reaction", function(e) {
      const platform = process.env.VUE_APP_PLATFORM;
      if (e.platform === platform) {
        if (JSON.stringify(e.user_id) === localStorage.getItem("userId")) {
          window.test.callReactionPusher(e.post_id, e.reactionCount);
        }
      }
    });
    //   System Notification End --------------------------------------------------------------------------------------------------------------
  },
};
</script>
<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 280px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  max-height: 100px;
  overflow: auto;
  top: -9px;
  right: 300px;
}
.pend-nvites{
  height: 20px;
    background: #ff5b66;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dropdown-content li,
.dropdown-menu li {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #557491 !important;
}
.dropdown-menu li:hover,
.dropdown-content li:hover {
  background-color: #f5f5f5;
  color: #557491 !important;
}

.dropdown:hover .dropdown-content {
  display: block;
}
.dropbtn {
  background-color: inherit;
  font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin: 0 !important;
    color: #557491 !important;
    border: none;
}
.dropdown:hover .dropbtn {
  background-color: inherit;
}
.lds-dual-ring-media:after {
    width: 20px;
    height: 20px;
  }
.association-img-loader {
    position: absolute;
    top: 50%;
    left: 90%!important;
    z-index: 99;
}
</style>
